/*
 * @Author       : yilei
 * @Date         : 2023-01-31 17:38:16
 * @LastEditTime : 2023-02-13 09:47:01
 * @LastEditors  : yilei
 */
import { MenuNode } from '@/services/api.d'
import { NEW_SYSTEM_BASE_PATH_LIST } from '../config'

const setTitleInfo = (title: string) => {
  requestAnimationFrame(() => {
    document.title = title || document.title
  })
  if (title) {
    const metaDescription = document.querySelector('meta[name="description"]')
    if (metaDescription) {
      metaDescription.setAttribute('content', title)
    }
    const metaKeywords = document.querySelector('meta[name="keywords"]')
    if (metaKeywords) {
      metaKeywords.setAttribute('content', title)
    }
  }
}

const setIconInfo = () => {
  const hostName: string = location.hostname

  // jikejia.cn
  let icoPath = '//pages.anjukestatic.com/img/jikejia/favicon_16x16.ico'
  if (hostName.indexOf('yfyk') === 0) {
    // yfyk.youfnagyouke.com
    icoPath = '//pages.anjukestatic.com/img/jikejia/favicon_third.ico'
  } else if (hostName.indexOf('mendian') === 0) {
    // mendian.58ganji.com
    icoPath =
      '//wos2.58cdn.com.cn/DeFazYxWvDti/frsupload/5b1713ae9b3031c18f2931df173a6f88_mendian_logo.ico'
  } else if (hostName.includes('fangzhentan')) {
    // 爬虫网站隐藏ico fangzhentan
    icoPath = ''
  }
  const iconEl = document.createElement('link')
  iconEl.setAttribute('rel', 'icon')
  iconEl.setAttribute('href', icoPath)
  document.head.appendChild(iconEl)
}

/**
 * 判断是否是属于新系统的链接
 * @param entry
 */
const isLinkInNewSystem = (entry: MenuNode) => {
  if (typeof entry.link === 'string') {
    return NEW_SYSTEM_BASE_PATH_LIST.some(baseLink => entry.link.includes(baseLink))
  }
  return false
}

export { setIconInfo, setTitleInfo, isLinkInNewSystem }
